<template>
  <van-overlay :show="show" @click="show = false">
    <div class="wrapper" @click.stop>
      <div class="content">
        <div class="header">
          <div class="left" @click="leftTextEvt">{{ leftText }}</div>
          <div class="middle title">{{ title }}</div>
          <div class="right" @click="rightTextEvt">{{ rightText }}</div>
        </div>
        <div class="body">
          <slot v-if="true"></slot>
        </div>
        <div class="footer" v-if="isFooter">
          <slot name="footer">
            <div class="left btn" @click="resetEvt">重置</div>
            <div class="right btn" @click="okEvt">确定</div>
          </slot>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { ref } from "vue";
export default {
  name: "FilterDialog",
  props: {
    title: {
      props: String,
      default: "标题",
    },
    leftText: {
      props: String,
      default: "",
    },
    rightText: {
      props: String,
      default: "取消",
    },
    isFooter: {
      props: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const show = ref(true);
    const stop = () => {};

    const leftTextEvt = () => {
      emit("left");
    };

    const rightTextEvt = () => {
      emit("right");
    };

    const resetEvt = () => {
      emit("reset");
    };
    const okEvt = () => {
      emit("ok");
    };
    return {
      show,
      stop,
      leftTextEvt,
      rightTextEvt,
      resetEvt,
      okEvt,
    };
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 100%;
  .content {
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    bottom: 0;
    border-radius: 8px 8px 0 0;
    background-color: #fff;
    padding: 0 15px;
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 54px;
      .middle {
        display: flex;
        flex: 1;
        height: 100%;
        align-items: center;
        justify-content: center;
      }
      .left,
      .right {
        display: flex;
        height: 100%;
        align-items: center;
        width: 60px;
      }
      .left {
        justify-content: flex-start;
      }
      .right {
        justify-content: flex-end;
      }
    }
    .body {
      min-height: 100px;
    }
    .footer {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 49px;

      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 165px;
        height: 36px;
        border-radius: 36px;
        &.left {
          color: #4174fdff;
          border: 1px solid #4174fdff;
        }
        &.right {
          color: #fff;
          background-color: #4174fdff;
        }
      }
    }
  }
}
</style>
